import styled from 'styled-components'

import theme from 'theme_'

export const StyledAddCardWrapper = styled.div`
  width: 100%;
`

export const StyledAddPaymentHeading = styled.div`
  color: ${theme.colors.moreGrey};
`
